class instagram {
    constructor (theme, elem) {
        this._elem = elem
        this._elem.dataset.componentId = this._elem.dataset.componentId || 'instagramFeed'
        this._elem.instagram = {
            'initiated': false
        }
        this._container = elem.querySelector('[data-instagram-container]')
        this._data = elem.querySelector('[data-settings]')
        if (this._data) {
            this._data.instagram = {
                'initiated': false
            }
        }
        this.breakpoint = 480
        this.evts = this.setEvents()
        if (this._data) {
            this.settings = this.getSettings(this._data.dataset)
        }
        if (this._data && this._data.dataset.instagramComponentId) {
            this._elem.dataset.componentId = this._data.dataset.instagramComponentId
        }
    }

    onInit () {
        if (!this.settings) return false
        this.fetchData('text', this.settings.shoppableUrl).then(response => {
            let tempElem = document.createElement('div')
            tempElem.innerHTML = response
            this.shoppable = {}
            this.shoppable.items = JSON.parse(tempElem.querySelector('#shoppableInstagram').innerHTML)
            this.shoppable.modal = tempElem.querySelector('#shoppableModal')
            this.fetchData('text', this.settings.url).then(response => {
                this.instagram = JSON.parse(response)
                this.fetchImgs()
                for (let [index, data] of this.instagram.data.entries()) {
                    if (data.videos) this.fetchVid(data, index)
                }
            })
        })
        document.body.addEventListener('overlay-hit', e => {
            this.turnModalOff(true)
        })
    }

    fetchImgs () {
        let count = 0
        for (let dataItem of this.instagram.data) {
            let url = dataItem.images.standard_resolution.url
            this.fetchData('blob', url).then(response => {
                count++
                if (count === this.instagram.data.length) this.createInstaFeed()
            })
        }
    }

    fetchVid (data, index) {
        data = data.videos.standard_resolution ? data.videos.standard_resolution : data.videos.low_resolution
        this.videos = this.videos ? this.videos : []
        let tempObj = {}
        tempObj.index = index
        tempObj.elemVideo = document.createElement('video')
        tempObj.elemVideo.height = data.height
        tempObj.elemVideo.controls = false
        tempObj.elemVideo.loop = true
        tempObj.elemVideo.muted = true
        tempObj.elemVideo.width = data.width
        tempObj.videoSource = data.url
        tempObj.elemSource = document.createElement('source')
        tempObj.elemSource.src = data.url
        tempObj.elemSource.type = 'video/mp4'
        tempObj.elemVideo.appendChild(tempObj.elemSource)
        this.videos.push(tempObj)
    }

    setEvents () {
        return {
            'initiated': new Event('initiated')
        }
    }

    createInstaFeed () {
        let elemContainer = document.createElement('div')
        elemContainer.classList.add('instagram-feed')
        this.items = []
        for (let dataItem of this.instagram.data) {
            let elemTemp = document.createElement('div')
            let elemBgArea = document.createElement('a')
            let linkSplit = dataItem.link.split('/')
            elemTemp.classList.add('instagram-item')
            elemTemp.dataset.bodyOverlayIgnore = ''
            elemBgArea.href = dataItem.link
            elemBgArea.dataset.shopId = linkSplit[linkSplit.length - 2]
            if (this.shoppable.items[elemBgArea.dataset.shopId]) {
                this.shoppable.items[elemBgArea.dataset.shopId].image = dataItem.images.standard_resolution
                elemBgArea.classList.add('has-modal')
            } else {
                this.shoppable.items[elemBgArea.dataset.shopId] = false
            }
            this.loadProductData(this.shoppable.items[elemBgArea.dataset.shopId])
            elemBgArea.addEventListener('mouseover', e => {
                if (window.innerWidth <= this.breakpoint) return false
                this.buildModal(this.shoppable.items[elemBgArea.dataset.shopId], dataItem)
            })
            elemBgArea.addEventListener('click', e => {
                if (!this.shoppable.items[elemBgArea.dataset.shopId]) return true
                if (window.innerWidth <= this.breakpoint) return true
                e.preventDefault()
                this.turnModalOn()
            })
            elemBgArea.style.backgroundImage = `url('${dataItem.images.standard_resolution.url}')`
            elemTemp.appendChild(elemBgArea)
            elemContainer.appendChild(elemTemp)
            this.items.push(elemTemp)
        }
        if (this.videos) {
            for (let vid of this.videos) {
                this.items[vid.index].classList.add('has-video')
                this.items[vid.index].querySelector('a').appendChild(vid.elemVideo)
            }
        }
        this.feed = elemContainer
        this.feed.instagram = {
            'initiated': false
        }
        this._elem.insertBefore(elemContainer, this._data.nextSibling)
        this.initiated(this.feed)
        this.initiated(this._elem)
        this.initiated(this._data)
        if (this.videos) this.playVideos()
    }

    buildModal (itemData, instaData) {
        if (!itemData.modal) {
            itemData.modal = this.shoppable.modal.cloneNode(true)

            let modalImg = itemData.modal.querySelector('img')
            let imgContainer = itemData.modal.querySelector('[data-img-container]')
            let tempPara = document.createElement('p')
            tempPara.classList.add('snippet')
            let contentContainer = itemData.modal.querySelector('[data-content-container]')

            for (let i = 0; i < itemData.length; i++) {
                let currData = itemData[i]
                let tempImg = document.createElement('img')
                let tempHeader = document.createElement('h5')
                let tempLink = document.createElement('a')
                tempImg.src = currData.json.featured_image
                tempLink.href = currData.json.url
                tempLink.style.left = currData.buttonPositions.x
                tempLink.style.top = currData.buttonPositions.y
                tempLink.title = currData.json.title
                tempLink.innerHTML = (i + 1)
                imgContainer.appendChild(tempLink)
                tempHeader.innerHTML = currData.json.title
                tempLink = document.createElement('a')
                tempLink.href = currData.json.url
                tempLink.title = 'Shop Now'
                tempLink.innerHTML = 'Shop Now'
                contentContainer.appendChild(tempImg)
                contentContainer.appendChild(productPrice(currData.json, this.formatMoney))
                contentContainer.appendChild(tempHeader)
                contentContainer.appendChild(tempLink)
            }

            modalImg.src = itemData.image.url
            tempPara.innerHTML = instaData.caption.text
            contentContainer.appendChild(tempPara)
        }

        this.shoppable.onPage = document.querySelector('#shoppableModal')

        if (!this.shoppable.onPage) {
            document.body.appendChild(this.shoppable.modal.cloneNode(true))
            this.shoppable.onPage = document.querySelector('#shoppableModal')
            this.shoppable.onPage.ref = this
        }

        this.shoppable.onPage.innerHTML = itemData.modal.innerHTML

        function productPrice (json, format) {
            let retElem = document.createElement('span')
            retElem.classList.add('productPrice')
            if (json.price < json.compare_at_price) {
                retElem.innerHTML = ''
                let tmpElem = document.createElement('span')
                tmpElem.classList.add('current-price')
                tmpElem.innerHTML = format(json.price)
                retElem.appendChild(tmpElem)
                retElem.innerHTML += '&nbsp;-&nbsp;'
                tmpElem = document.createElement('span')
                tmpElem.classList.add('old-price')
                tmpElem.innerHTML = format(json.compare_at_price)
                retElem.appendChild(tmpElem)
                return retElem
            }
            retElem.classList.add('current-price')
            retElem.innerHTML = format(json.price)
            return retElem
        }
    }

    turnModalOn () {
        this.shoppable.onPage.classList.add('on')
        this.shoppable.onPage.open = true
        document.body.classList.add('overlay')
        document.body.overlayStatus = true
    }

    turnModalOff (overlay) {
        this.shoppable.onPage.classList.remove('on')
        this.shoppable.onPage.open = false
        if (!overlay) {
            document.body.classList.remove('overlay')
            document.body.overlayStatus = false
        }
    }

    loadProductData (itemData) {
        if (itemData.loadedAll) return this.buildModal(itemData)
        let loadCount = 0
        for (var i = itemData.length; i--;) {
            let currItemData = itemData[i]
            if (currItemData.loaded) continue
            this.fetchData('text', `/products/${currItemData.productHandle}.js`).then(data => {
                currItemData.json = JSON.parse(data)
                loadCount++
                if (currItemData.json.featured_image) {
                    this.fetchData('blob', currItemData.json.featured_image)
                }
                if (loadCount !== itemData.length) return false
                itemData.loadedAll = true
            })
            currItemData.loaded = true
        }
    }

    playVideos () {
        for (let vid of this.videos) {
            vid.elemVideo.play()
        }
    }

    initiated (elem) {
        elem.instagram.initiated = true
        this.evts.initiated.ref = this
        elem.classList.add('initiated')
        elem.dispatchEvent(this.evts.initiated)
        return true
    }

    fetchData (type, url) {
        return new Promise((resolve, reject) => {
            let request = new XMLHttpRequest()
            request.open('GET', url)
            request.responseType = type
            request.onload = () => {
                if (request.status === 200) {
                    resolve(request.response)
                } else {
                    reject(Error(`Data couldnt be retrieved, error code: ${request.statusText}`))
                }
            }
            request.onerror = (e) => {
                reject(Error('There was a network error.'))
            }
            request.send()
        })
    }

    getImg (url) {
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = () => {
                resolve(url)
            }
            img.onerror = () => {
                reject(url)
            }
            img.src = url
        })
    }

    getSettings (dataset) {
        let retObj = {}
        let instagramData = dataset.settings
        if (!instagramData) return false
        instagramData = instagramData.split('|')
        retObj.accessCode = instagramData[0]
        retObj.amountToDisplay = instagramData[1]
        retObj.url = `https://api.instagram.com/v1/users/self/media/recent/?access_token=${retObj.accessCode}&count=${retObj.amountToDisplay}`
        retObj.shoppableUrl = instagramData[2]
        return retObj
    }

    formatMoney (cents, format) {
        if (typeof cents === 'string') { cents = cents.replace('.', '') }
        var value = ''
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
        var formatString = (format || window.theme.moneyFormat)

        function defaultOption (opt, def) {
            return (typeof opt === 'undefined' ? def : opt)
        }

        function formatWithDelimiters (number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2)
            thousands = defaultOption(thousands, ',')
            decimal = defaultOption(decimal, '.')

            if (isNaN(number) || number == null) { return 0 }

            number = (number / 100.0).toFixed(precision)

            var parts = number.split('.')
            var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
            var cents = parts[1] ? (decimal + parts[1]) : ''

            return dollars + cents
        }

        switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2)
            break
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0)
            break
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',')
            break
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',')
            break
        }

        return formatString.replace(placeholderRegex, value)
    }
}

export default instagram



// WEBPACK FOOTER //
// ./src/scripts/components/Instagram.js